<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "@/views/workOrder/question.vue";
export default {
  extends: baseEdit,
  components: {
    change: Change,
  },
  props: {
    id: {
      type: String,
      value: "",
    },
    createBy: {
      type: String,
      value: "",
    },
    action: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "",
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "选择故障类型",
          name: "typeId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
          // desc: "如确认非硬件问题请选择关联性报修！",
          rules: [
            {
              required: true,
              message: "故障类型不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
          onChange: this.onChangetypes,
        },
        {
          label: "问题描述",
          name: "descr",
          value: "",
          dropList: [],
          type: "pullinput",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
          onFocus: this.onTextFocus,
          onChange: this.onTextChange,
          onExtClick: this.onTextExtClick,
        },
        { label: "处理结果", name: "process", value: "", type: "input" },
      ],
      forms: {
        descr: "",
      },
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  created() {
    this.loadworkData();
  },
  methods: {
    loadworkData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "typeId") {
              this.items[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    onTextChange(val) {},
    onTextFocus() {},
    onTextExtClick() {
      let _this = this;
      // 按钮显示常用语
      if (this.$refs.change && this.$refs.change[0]) {
        this.$refs.change[0].open();
        this.$refs.change[0].getText = (val) => {
          _this.forms.descr += val + "";
        };
        // this.forms.descr=_this.forms.descr
      }
    },
    handleSubmit() {
      let id = this.id;
      let q = {};
      q.id = id;
      q.solve = 1;
      q.typeId = this.forms.typeId;
      q.descr = this.forms.descr;
      q.process = this.forms.process;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/record`, q, "PUT")
        .then((res) => {
          this.sloading = false;
          if (res.status) {
            $utils.toast.success("保存成功");
            $utils.url.go(0);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    // initData() {
    //   // 加载详情数据
    //   $form.initData(this, {}, (res) => {
    //     if (res.scope_type == 1) {
    //       // this.items[2].type = 'kong'
    //       this.items[this.getItemIndex('community_id')].type = 'kong'
    //       this.forms.community_id = ''
    //     }
    //     if (res.scope_type == 2) {
    //       //  this.items[2].type = 'select'
    //       this.items[this.getItemIndex('community_id')].type = 'select'
    //     }
    //     if (res) {
    //       this.forms = res
    //     }
    //   })
    // },
  },
};
</script>
